import * as Yup from 'yup';

export const initialValues = {
  name: '',
  cpf: '',
  email: '',
  phone: '',
  _error: ''
};

export type Values = {
  name: string;
  cpf: string;
  email: string;
  phone: string;
  _error?: string;
};

export const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Mínimo de 5 caracteres!')
    .max(50, 'Máximo de 50 caracteres!')
    .required('Preencha este campo.'),
  cpf: Yup.string()
    .min(11, 'Mínimo de 11 caracteres!')
    .max(14, 'Máximo de 14 caracteres!')
    .required('Preencha este campo.'),
  email: Yup.string().email('E-mail inválido!').required('Preencha este campo.'),
  phone: Yup.string().required('Preencha este campo.')
});

export const cpfMask = (value: string) => {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}